import React, { HTMLAttributes } from 'react';
import Immutable from 'immutable';
import { useSelector } from 'react-redux';

import { Paragraph } from '@uncinc/react-drupal-core';
import { ImmutableRootState } from '@uncinc/react-drupal-core/types';

import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import useClasses from '../../../hooks/useClasses';
import { ImmutableGenericNodeEntity } from '..';

import './style.scss';

interface Props extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableGenericNodeEntity;
}

const NodeBasicPage: React.FC<Props> = ({ entity }) => {
  const { buildClass, joinClasses } = useClasses('NodeBasicPage');

  const title = entity.getIn(['title', 0, 'value'], '');
  const body = entity.getIn(['body', 0, 'processed'], '');
  const paragraphs = entity.get('field_paragraphs', Immutable.List());

  const isLoggedIn = useSelector<ImmutableRootState<boolean>, boolean>((state) => state.getIn(['login', 'loggedIn'], null));

  const Hero = () => (
    <>
      <div className={buildClass('title')}>
        <h1>{title}</h1>
      </div>

      {body.length > 0 && (
        <div className={buildClass('body')}>
          <WysiwygField
            property="schema:text"
            html={body}
          />
        </div>
      )}
    </>
  );

  const Paragraphs = () => (
    <>
      {paragraphs.size > 0 && (
        <>
          {paragraphs.map((paragraph) => {
            const id: number = paragraph.get('target_id');
            const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
            return (
              <Paragraph
                key={`paragraph:${id}:${language}`}
                id={id}
                entity={paragraph.get('entity')}
              />
            );
          })}
        </>
      )}
    </>
  );

  if (!isLoggedIn) {
    return (
      <Container>
        <div className="row">
          <div className={joinClasses(buildClass(), 'col-12 col-md-10 col-lg-8 offset-md-1 offset-lg-2 py-8 py-lg-12')}>
            <Hero />
            <Paragraphs />
          </div>
        </div>
      </Container>
    );
  }

  return (
    <div className={joinClasses(buildClass(), 'col-12 col-md-8 offset-md-2 offset-lg-1 py-8 py-lg-12')}>
      <Hero />
      <Paragraphs />
    </div>
  );
};

export default NodeBasicPage;
